/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * description the type of email audited
 * @export
 */
export const AuditType = {
    Invoice: 'INVOICE',
    Reminder: 'REMINDER',
    Account: 'ACCOUNT',
    Other: 'OTHER',
    Product: 'PRODUCT'
} as const;
export type AuditType = typeof AuditType[keyof typeof AuditType];


export function AuditTypeFromJSON(json: any): AuditType {
    return AuditTypeFromJSONTyped(json, false);
}

export function AuditTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditType {
    return json as AuditType;
}

export function AuditTypeToJSON(value?: AuditType | null): any {
    return value as any;
}

